module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/user-picture/user-picture.component.scss
// module id = ./src/app/components/user-picture/user-picture.component.scss
// module chunks = main